// test2641
(2641 && 0);
